/**
 * Enriches data rows with human-readable labels from metadata value_label mappings
 * @param {Array} data - Array of data objects
 * @param {Object} metadata - Metadata object containing fields with value_label mappings
 * @param {string} categoryField - The field name to look up labels for
 * @returns {Array} - Enriched data array (original data if no labels found)
 */
export function enrichDataWithLabels(data, metadata, categoryField) {
	// Return original data if inputs are invalid
	if (!Array.isArray(data) || !metadata || !categoryField) {
	  return data;
	}
  
	// Check if value_label mapping exists for this field
	const fieldMetadata = metadata.fields?.[categoryField];
	const valueLabels = fieldMetadata?.value_label;
  
	if (!Array.isArray(valueLabels) || valueLabels.length === 0) {
	  return data;
	}
  
	// Create a lookup map for O(1) access
	const labelMap = new Map(
	  valueLabels.map(item => [String(item.value), item.label])
	);
  
	// Enrich data with labels (non-mutating)
	return data.map(row => {
	  const value = row[categoryField];
	  const label = labelMap.get(String(value));
  
	  // Only add label if found, otherwise return original row
	  return label ? { ...row, label } : row;
	});
  }